import { BaseFill } from './base-fill';
import { alphaToOpacity } from '@framework/workbench/drawer/utils';
import { ISolidFill } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import type { ColorFrom } from '@tencent/workbench';
import type { NumberInputFrom } from '@tencent/wb-ext-form';
import { SolidFill as SolidFillColor } from '@src/slide/domain/ui-model/plugin/referModels/FillClass';
import { FormItemName } from '@framework/workbench/drawer/constants';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { STSchemeColorVal } from '@tencent/slide-sdk-pb-model/src/ultrabuf/ultrabuf.types';

interface ISolidValue {
    solidFillColor: TDColor;
}

export interface ISolidFillProps {
    rgbaStr?: string;
    themeKey?: STSchemeColorVal;
}

export class SolidFill extends BaseFill {
    public value: ISolidValue;
    public constructor(props?: ISolidFillProps) {
        super();
        this.value = {
            solidFillColor: new TDColor(props || { themeKey: STSchemeColorVal.accent1 }),
        };
    }

    public initPropsCb = (fillInfo?: ISolidFill) => {
        this.value.solidFillColor = fillInfo?.color
            || this.value.solidFillColor
            || new TDColor({ themeKey: STSchemeColorVal.accent1 });
    };

    public getSolidOpacity = (): number => alphaToOpacity(this.value.solidFillColor.alpha);

    public handleSolidColorChange = (tdColor: TDColor, from: ColorFrom | number, onlyChangeUI) => {
        this.value.solidFillColor = tdColor;
        this.confirmSolidChoice(this.value.solidFillColor, onlyChangeUI);
    };

    public handleSolidOpacityChange(opacity: number, from?: NumberInputFrom, dragEnd?: boolean) {
        this.value.solidFillColor.updateOpacity(opacity);
        const onlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        this.confirmSolidChoice(this.value.solidFillColor, onlyChangeUI);
        this.tdwDrawerReportNumberInput(FormItemName.SOLID_FILL_OPACITY, { ver6: opacity }, from, onlyChangeUI);
    }

    public confirmSolidChoice = (tdColor: TDColor | null, onlyChangeUI?: boolean) => {
        if (tdColor) {
            const solidFill = new SolidFillColor();
            solidFill.color = tdColor;
            this.updateFillProps({ solidFill }, onlyChangeUI);
        } else { // 无填充
            this.updateFillProps({ noFill: 1 }, onlyChangeUI);
        }
    };
}
